import React, { useMemo, useState } from 'react';

import type { BackBehaviorOverride } from './BackBehaviorOverride';
import { BackBehaviorOverrideContext } from './BackBehaviorOverrideContext';

export function BackBehaviorOverrideProvider({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element {
	const [override, setOverride] = useState<BackBehaviorOverride | null>(null);
	const value = useMemo(() => ({ override, setOverride }), [override]);
	return (
		<BackBehaviorOverrideContext.Provider value={value}>
			{children}
		</BackBehaviorOverrideContext.Provider>
	);
}
